// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"radio__wrapper-1Lco_","radio":"radio__radio-3_Xob","title":"radio__title-1Ws42","label":"radio__label-1Fb1A"};


//////////////////
// WEBPACK FOOTER
// ./packages/account-ui/radio/radio.css
// module id = 870
// module chunks = 0